import Vue from 'vue'
import { Button, Tabs, LocaleProvider, Modal, message, Popover, Spin } from 'ant-design-vue'
import '@/assets/css/l8-model.less'
import moment from 'moment'
import passengerSegList from '@/components/passenger-seg-list'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Tabs)
Vue.use(LocaleProvider)
Vue.use(Modal)
Vue.use(Popover)
Vue.use(Spin)
Vue.use(passengerSegList)

Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.moment = moment
